import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../environment";
import {
  CorpPayor,
  CorpPayorDropdowns,
  CorpPayorFacilityData,
  CorpPayorListItem,
} from "../interfaces/corp-payor.interface";
import { ListResponse } from "../interfaces/list-response.interface";
import { PayorFacility } from "../interfaces/payor.interface";

@Injectable({ providedIn: "root" })
export class CorpPayorClient {
  endpoint = "corpPayor";
  constructor(private httpClient: HttpClient) {}

  addPayor(corpPayor: CorpPayor) {
    return this.httpClient.post(
      `${environment.endpoint}/${this.endpoint}/add`,
      corpPayor
    );
  }

  editPayor(corpPayor: CorpPayor) {
    return this.httpClient.put(
      `${environment.endpoint}/${this.endpoint}/edit`,
      corpPayor
    );
  }

  getPayor(id: string): Observable<CorpPayor> {
    return this.httpClient.get<CorpPayor>(
      `${environment.endpoint}/${this.endpoint}/get/${id}`
    );
  }

  getPayorList(
    corporationId: string
  ): Observable<ListResponse<CorpPayorListItem>> {
    return this.httpClient.get<ListResponse<CorpPayorListItem>>(
      `${environment.endpoint}/${this.endpoint}/payorplanlist/${corporationId}`
    );
  }

  getPayorPlanDropdowns(corpId: string): Observable<CorpPayorDropdowns> {
    return this.httpClient.get<CorpPayorDropdowns>(
      `${environment.endpoint}/${this.endpoint}/dropdowns/${corpId}`
    );
  }

  getPayorFacilities(
    payorId: string,
    corporationId: string
  ): Observable<CorpPayorFacilityData> {
    return this.httpClient.get<CorpPayorFacilityData>(
      `${environment.endpoint}/${this.endpoint}/get-payor-facilities/payor/${payorId}/corp/${corporationId}`
    );
  }

  editPayorFacilities(facilities: PayorFacility[]): Observable<unknown> {
    return this.httpClient.put(
      `${environment.endpoint}/${this.endpoint}/edit-payor-facilities`,
      facilities
    );
  }

  validateActivePatientsForPayor(payorId: string): Observable<
    ListResponse<{
      patientname: string;
      facilityname: string;
      fromdate: string;
    }>
  > {
    return this.httpClient.get<
      ListResponse<{
        patientname: string;
        facilityname: string;
        fromdate: string;
      }>
    >(
      `${environment.endpoint}/${this.endpoint}/validate-active-patient/payor/${payorId}`
    );
  }
}
